import { render } from "./HeaderTimeAccountsMarca.vue?vue&type=template&id=68e8815c&scoped=true&ts=true"
import script from "./HeaderTimeAccountsMarca.ts?vue&type=script&lang=ts&external"
export * from "./HeaderTimeAccountsMarca.ts?vue&type=script&lang=ts&external"

import "./HeaderTimeAccountsMarca.vue?vue&type=style&index=0&id=68e8815c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e8815c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QLinearProgress});
